/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_ar_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`What are the most common aspect ratios?`)
};

const es_ar_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Cuáles son las relaciones de aspecto más comunes?`)
};

const de_ar_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Was sind die gängigsten Seitenverhältnisse?`)
};

const nl_ar_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wat zijn de meest voorkomende beeldverhoudingen?`)
};

const fr_ar_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quels sont les rapports d'aspect les plus courants ?`)
};

const it_ar_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quali sono i rapporti di aspetto più comuni?`)
};

const pt_br2_ar_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quais são as taxas de aspecto mais comuns?`)
};

const pt_ar_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quais são as proporções de aspecto mais comuns?`)
};

const ja_ar_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`最も一般的なアスペクト比は何ですか？`)
};

const zh_ar_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`最常见的宽高比有哪些?`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const ar_faq4_q = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.ar_faq4_q(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("ar_faq4_q", locale)
	if (locale === "en") return en_ar_faq4_q(inputs)
	if (locale === "es") return es_ar_faq4_q(inputs)
	if (locale === "de") return de_ar_faq4_q(inputs)
	if (locale === "nl") return nl_ar_faq4_q(inputs)
	if (locale === "fr") return fr_ar_faq4_q(inputs)
	if (locale === "it") return it_ar_faq4_q(inputs)
	if (locale === "pt-BR") return pt_br2_ar_faq4_q(inputs)
	if (locale === "pt") return pt_ar_faq4_q(inputs)
	if (locale === "ja") return ja_ar_faq4_q(inputs)
	return zh_ar_faq4_q(inputs)
};